/* eslint-disable consistent-return */
import Cookies from 'js-cookie';
import { login } from './authenticate';
import { kImpersonationFlagKey } from './constants';
import getters from './getters';
import { renewToken } from './helpers';

let checkIntervalSeconds = 0;
let checkSessionInterval = null;

const millisecsInOneSec = 1000;
const renewAttempts = 5;

export const checkSession = () => {
	const { tokenExp } = getters;
	if (!tokenExp) {
		window.clearInterval(checkSessionInterval);
		login();
		return;
	}

	const dateDiff =
		(tokenExp.getTime() - new Date().getTime()) / millisecsInOneSec;
	const shouldRenew = dateDiff < checkIntervalSeconds * renewAttempts;

	if (shouldRenew) {
		const isTokenExpired = dateDiff <= 0;

		if (isTokenExpired) {
			window.clearInterval(checkSessionInterval);
			Cookies.remove(kImpersonationFlagKey);
			return login();
		}

		return renewToken();
	}
};

const setupSessionMonitoring = checkIntervalSec => {
	checkIntervalSeconds = checkIntervalSec;

	checkSessionInterval = window.setInterval(
		checkSession,
		checkIntervalSeconds * millisecsInOneSec
	);
};

export default setupSessionMonitoring;



// WEBPACK FOOTER //
// ./src/sso-auth/monitoring.js